module.exports = fox._r("images/_tips-img.jpg", __webpack_public_path__ + "images/_tips-img.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/_tips-img.jpg
// module id = 963
// module chunks = 4